import {
    SET_ASSIGNMENT_TRANSFER_TYPES,
} from "./AssignmentTransferTypesType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_ASSIGNMENT_TRANSFER_TYPES:
            return {
                ...state,
                assignmentTransferTypesList: action.assignmentTransferTypesList,
            };
        default:
            return state;
    }
};

export {
    reducers
}
